/**
 * DebugHelper — mirrors ConneXt v2 DebugHelper.
 * Utility functions for the debug panel.
 */
export class DebugHelper {
    static elById(id) {
        return document.getElementById(id);
    }
    static generateHtmlOptionElement(value, text, selected) {
        return `<option value="${value}" ${selected ? 'selected' : ''}>${text}</option>`;
    }
    static reloadApplication() {
        window.location.reload();
    }
    static switchShowDomBlock(condition, block) {
        if (!block)
            return;
        block.style.display = condition ? '' : 'none';
    }
    static wrapValueIfEmpty(value) {
        return value ? String(value) : '...';
    }
    static removePanel() {
        var _a;
        (_a = this.elById('EngagePanelDebugger')) === null || _a === void 0 ? void 0 : _a.remove();
    }
}
